import InvestmentFundsCard from './InvestmentFundsCard';

export default InvestmentFundsCard;